import React from "react";
import { NavLink } from "react-router-dom";
import { UnorderedList, ListItem, Text, Box } from "@chakra-ui/react";
import { ClassIcon } from "../../Icons/ClassIcon";

export const ClassList = ({ classes, title, onClose, userRole }) => {
  return (
    <Box padding="10px 20px">
      <Text>{title}</Text>
      {classes.length === 0 && userRole === "Student" && (
        <Text>You are not enrolled in any class.</Text>
      )}
      <UnorderedList>
        {React.Children.toArray(
          classes.map((clss) => (
            <NavLink to={`/class/${clss.id}`} onClick={onClose}>
              <ListItem className="class-item">
                <ClassIcon />
                <Text margin="0 0 0 5px">{clss.name}</Text>
              </ListItem>
            </NavLink>
          ))
        )}
      </UnorderedList>
    </Box>
  );
};
